export const environment = {
  production: true,
  apiUrl: 'https://api.smartlions.center',
  meWrapperApiUrl: 'https://api.smartlions.me',
  mercureUrl: 'https://mercure.smartlions.center/.well-known/mercure',
  websocketEndpointListener: 'live'
};
